import { ArrowsClockwise } from '@phosphor-icons/react';

export default ArrowsClockwise;
